import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 5,
    type: CHECKLIST_ITEM_TYPE.CURRENCY_AMOUNT,
    manifestKey: 'CURRENCY_AMOUNT',

    try_it: {
        button_label: 'Enter Currency Amount',
        // Structured-data types fall through to ConfirmationCell (default) in the switch — no dedicated cell exists yet.
        // Wave 3 will render ConfirmationCell as placeholder and note the gap.
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'ConfirmationCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { amount: 5000 },
        },
    },
    pre_flight_diff: [
        '⚠ value will NOT persist — known bug (BE-#273-cleanup)',
        'PATCH /checklist/{iid}/ with value field → 200 but value silently dropped',
        'Checklist item: PENDING → YES (via complete POST, NOT via PATCH)',
        'TaskActivity row created with action CHECKLIST_ITEM_COMPLETED',
        'Amount can be stored in response_payload on complete POST (workaround)',
    ],
    has_step2_throttle: false,
    validation_laboratory: [
        {
            label: 'PATCH value="test" (silent-drop)',
            body: { value: 'test' },
            expected: '200 but value not persisted (silent drop) — GET confirms field absent',
        },
        {
            label: 'PATCH value="5000" (numeric string)',
            body: { value: '5000' },
            expected: '200 but value not persisted — confirms bug applies to all value types',
        },
    ],
};
